import { render, staticRenderFns } from "./guessTable3.vue?vue&type=template&id=36537910&"
import script from "./guessTable3.vue?vue&type=script&lang=js&"
export * from "./guessTable3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports